import WishlistShareSection from '../wishlist-share-section'
import { WishlistShareSectionProps } from '../wishlist-share-section/wishlist-share-section'

import styles from './wishlist-heading.module.scss'

type PropType = {
  name?: string
  isSelfWishlist?: boolean
} & Pick<WishlistShareSectionProps, 'wishListProductList'>

function WishlistHeading({ name, isSelfWishlist, wishListProductList }: PropType) {
  return (
    <div className={styles.headingWrapper}>
      <h1 className={styles.heading}>{name ? `${name}'s Favorites` : 'My Favorites'}</h1>
      {name ? <div className={styles.subHeading}>Here&apos;s what&apos;s on their wishlist.</div> : null}
      {isSelfWishlist ? <WishlistShareSection wishListProductList={wishListProductList} /> : null}
    </div>
  )
}

export default WishlistHeading
